var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-textarea-box__wrapper", class: _vm.showBefore },
    [
      _c("div", { staticClass: "c-textarea-box" }, [
        _c("div", { staticClass: "c-textarea-box__question" }, [
          _c("h2", { staticClass: "c-textarea-box__title" }, [
            _vm._v(_vm._s(_vm.question.label))
          ]),
          _vm._v(" "),
          _vm.question.helpText
            ? _c("div", {
                staticClass: "c-rap-rte",
                domProps: { innerHTML: _vm._s(_vm.question.helpText) }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-textarea-box__answer" }, [
          _c("div", { staticClass: "c-form-textarea" }, [
            _c(
              "label",
              {
                staticClass: "c-form-textarea__label",
                class: {
                  "c-form-textarea__label--required": _vm.question.mandatory
                },
                attrs: { for: _vm.question.id }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.question.fieldLabel) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.question.answer,
                  expression: "question.answer"
                }
              ],
              staticClass: "c-form-textarea__control",
              class: { "c-form-textarea__control--is-invalid": _vm.isInvalid },
              attrs: {
                cols: "50",
                rows: "10",
                maxlength: "500",
                id: _vm.question.id,
                name: _vm.question.id,
                "aria-label": _vm.question.id
              },
              domProps: { value: _vm.question.answer },
              on: {
                change: _vm.onChange,
                focus: _vm.onFocus,
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.question, "answer", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.isInvalid
              ? _c(
                  "span",
                  {
                    staticClass: "c-form-input__validation-message",
                    attrs: { "aria-label": _vm.question.validation }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.question.validation) +
                        "\n        "
                    )
                  ]
                )
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _vm.question.text
          ? _c("div", {
              staticClass: "c-rap-rte",
              domProps: { innerHTML: _vm._s(_vm.question.text) }
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.isSubmitted
          ? _c("div", { staticClass: "c-textarea-box__actions" }, [
              _c(
                "button",
                {
                  staticClass: "c-button c-button--brand c-button--text-center",
                  attrs: { type: "button" },
                  on: { click: _vm.emitInput }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.question.buttonText) + "\n      "
                  )
                ]
              )
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72e3f23e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72e3f23e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/consumer/report-a-problem/_vue/TextareaBox.vue
// module id = 706
// module chunks = 0